import React, {Fragment, Component} from "react";
import Login                        from './services/login';
import {isFreeUser}       from './user';
import {hasAuth}                    from './services/api';

class HOCRequireAuth extends Component {
    constructor(props) {
        super(props)
        this.authorize = this.authorize.bind(this)
    }
    componentDidMount() {
        this.authorize()
    }
    UNSAFE_componentWillUpdate() {
        this.authorize()
    }
    authorize() {
        if (!hasAuth() && !isFreeUser() && !hasAuth() && isFreeUser()) {

            Login()
        }
    }
    render(){
        return <Fragment>{this.props.children}</Fragment>
    }
}

export default HOCRequireAuth
